export class DataInput {
	wordsList: string;
	text: string;

	constructor(wordsInput, textInput) {
		this.wordsList = wordsInput;
		this.text = textInput;
	}
}
